import React from 'react';
import {
    PictureAsPdfRounded,
    ChevronLeft
} from '@mui/icons-material';

const Shimmer = ({width, height, className = ''}) => (
    <div
        className={`bg-gray-200 animate-pulse rounded-md ${className}`}
        style={{width, height}}
    />
);

function BookDetailShimmer() {
    return (
        <div className="bg-gray-50">
            <div className="container mx-auto px-4 py-8 lg:px-[5%]">
                {/* Back Button Shimmer */}
                <div className="mb-6 flex items-center">
                    <ChevronLeft className="mr-2 text-gray-300"/>
                    <Shimmer width="100px" height="24px"/>
                </div>

                {/* Book Header Shimmer */}
                <div
                    className="relative rounded-xl overflow-hidden shadow-lg mb-8 h-[350px] md:h-[400px] bg-gray-200 animate-pulse flex flex-col justify-end"
                >
                    <div className="p-6 text-white z-10 space-y-3">
                        <Shimmer width="120px" height="16px" className="mb-2"/>
                        <Shimmer width="250px" height="32px" className="mb-4"/>
                        <Shimmer width="180px" height="20px"/>
                    </div>
                </div>

                {/* Description Section Shimmer */}
                <div className="bg-white rounded-lg p-6 mb-8 shadow-sm">
                    <Shimmer width="100px" height="24px" className="mb-4"/>
                    <div className="space-y-3">
                        <Shimmer width="100%" height="16px"/>
                        <Shimmer width="95%" height="16px"/>
                        <Shimmer width="80%" height="16px"/>
                    </div>
                </div>

                {/* Attached Files Section Shimmer */}
                <div className="bg-white rounded-lg p-6 mb-4 shadow-sm">
                    <Shimmer width="150px" height="24px" className="mb-4"/>
                    <div className="space-y-3">
                        {[1, 2, 3].map((item) => (
                            <div
                                key={item}
                                className="flex items-center hover:bg-gray-50 p-2 rounded-md"
                            >
                                <PictureAsPdfRounded className="text-gray-300 mr-3"/>
                                <Shimmer width="200px" height="20px"/>
                            </div>
                        ))}
                    </div>
                </div>

                {/* External Links Section Shimmer */}
                <div className="bg-white rounded-lg p-6 shadow-sm">
                    <Shimmer width="150px" height="24px" className="mb-4"/>
                    <div className="space-y-3">
                        {[1, 2].map((item) => (
                            <div
                                key={item}
                                className="flex items-center hover:bg-gray-50 p-2 rounded-md"
                            >
                                <Shimmer width="200px" height="20px"/>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BookDetailShimmer;